// App
const DashboardWrapper = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "home" */ '@/components/DashboardWrapper.vue');
const HomeView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "home" */ '@/views/Dashboard/HomeView.vue');
const DashboardView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "home" */ '@/views/Dashboard/DashboardView.vue');
const EstrategicoView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "home" */ '@/views/Dashboard/EstrategicoView.vue');

// Processos
const ProcessoKanbanView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "processos" */ '@/views/Processos/ProcessoKanbanView.vue');
const AberturaProcessoView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "processos" */ '@/views/Processos/AberturaProcessoView.vue');
const ProcessoListagemView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "processos" */ '@/views/Processos/ProcessoListagemView.vue');

// KPIs
const UsuariosView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "usuarios" */ '@/views/Usuarios/UsuariosView.vue');

// Agendamento Relatórios
const AgendamentoRelatorioView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "agendamento_relatorios" */ '@/views/AgendamentoRelatorio/AgendamentoRelatorioView.vue');

// Estoque
const EstoqueView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "Estoque" */ '@/views/Armazenamento/Estoque/EstoqueView.vue');

// Ged
const GedView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "ged" */ '@/views/Usuarios/GedView.vue');

// Armazém
const ArmazemPrevisao = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "expedicao" */ '@/views/Armazenamento/Armazem/PrevisaoDemandaDomesticaView.vue');
const AcuraciaEstoque = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "expedicao" */ '@/views/Armazenamento/Acuracia/AcuraciaView.vue');
const AcuraciaArmazem = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "expedicao" */ '@/views/Armazenamento/Acuracia/AcuraciaArmazemView.vue');

// Financeiro
const CambioView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cambio" */ '@/views/Financeiro/CambioView.vue');

// Gestão de LIs
const GestaoLIView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gestaoLI" */ '@/views/GestaoLI/GestaoLIView.vue');

// Processos Pendentes
const ProcessosPendentesView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "processosPendentes" */ '@/views/Processos/ProcessosPendentesView.vue');

// Containers
const ContainersView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "Containers" */ '@/views/Containers/ContainersView.vue');

// Transit time
const TransitView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "transito" */ '@/views/TransitTime/TransitTime.vue');

// Custos de armazém
const CustosArmazemView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "custos-armazem" */ '@/views/Armazenamento/Armazem/CustosView.vue');

// Empresas
const EmpresasView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "empresas" */ '@/views/Empresas/EmpresasView.vue');

// Incentivo Fiscal
const IncentivoFiscalView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "incentivo-fiscal" */ '@/views/Relatorios/IncentivoFiscalView.vue');

// CadastroBasicos
const CadastroBasicoView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cadastro-basico" */ '@/views/CadastrosBasicos/CadastroBasicoMainView.vue');

const CrcView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "incentivo-fiscal" */ '@/views/CRC/CrcView.vue');

// Simulação
const SimulacaoView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "simulacao" */ '@/views/Simulacao/SimulacaoView.vue');

// Processos afiliados (Usuário consultor)
const ProcessosParceirosView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "processosParceiros" */ '@/views/Processos/ProcessosParceirosView.vue');

// Processos afiliados (Usuário consultor)
const ProcessosComissaoView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "processosComissao" */ '@/views/Processos/ProcessosComissaoView.vue');

const DashboardContainerView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "DashboardContainerView" */ '@/views/Containers/DashboardContainersView.vue');

// Funcionalidades Internas Trust
const TarefasView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "tarefas" */ '@/views/Interno/Tarefas/TarefasView.vue'); // Gestao de Tarefas
const MercadoHojeView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "MercadoHojeView" */ '@/views/Interno/MercadoHoje/MercadoHojeView.vue');
const DespesasImportacaoDetalhamentoView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "DespesasImportacaoDetalhamentoView" */ '@/views/DespesasImportacaoDetalhamento/DespesasImportacaoDetalhamentoView.vue');

const routes = [
  {
    path: '/',
    component: DashboardWrapper,
    children: [
      {
        path: '/',
        name: 'Home',
        component: HomeView,
      },
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: DashboardView,
      },
      {
        path: '/estrategico',
        name: 'estrategico',
        component: EstrategicoView,
      },
      {
        path: '/custos-armazem',
        name: 'CustosArmazem',
        component: CustosArmazemView,
      },
      // Simulação
      {
        path: '/simulacao',
        name: 'Simulacao',
        component: SimulacaoView,
      },
      // Transit
      {
        path: '/tempo-transito',
        name: 'TransitTime',
        component: TransitView,
      },

      // Internos Trust

      // Gestao de Tarefas
      {
        path: '/tarefas',
        name: 'Tarefas',
        component: TarefasView,
      },

      // Mercado Hoje
      {
        path: '/mercado-hoje',
        name: 'mercadoHoje',
        component: MercadoHojeView,
      },

      // Processos
      {
        path: '/processos/kanban',
        name: 'ProcessosKanban',
        component: ProcessoKanbanView,
      },
      {
        path: '/processos/solicitacao',
        name: 'AberturaProcesso',
        component: AberturaProcessoView,
      },
      {
        path: '/processos/listagem',
        name: 'ListagemProcesso',
        component: ProcessoListagemView,
      },
      {
        path: '/processos/pendentes',
        name: 'processosPendentes',
        component: ProcessosPendentesView,
      },

      // Usuários
      {
        path: '/usuarios/:id?',
        name: 'ListarUsuarios',
        component: UsuariosView,
      },

      // Agendamento
      {
        path: '/agendamento-relatorios',
        name: 'AgendamentoRelatorios',
        component: AgendamentoRelatorioView,
      },

      // Estoque
      {
        path: '/estoque',
        name: 'Estoque',
        component: EstoqueView,
      },

      // GED
      {
        path: '/ged',
        name: 'Ged',
        component: GedView,
      },

      // Armazém
      {
        path: '/previsao-demanda-domestica',
        name: 'PrevisaoDemandaDomestica',
        component: ArmazemPrevisao,
      },
      {
        path: '/acuracia-estoque',
        name: 'acuraciaEstoque',
        component: AcuraciaEstoque,
      },
      {
        path: '/acuracia-armazem',
        name: 'acuraciaArmazem',
        component: AcuraciaArmazem,
      },

      // Financeiro
      {
        path: '/financeiro',
        name: 'Financeiro',
        component: CambioView,
      },

      // Gestão de LIs
      {
        path: '/gestao-li',
        name: 'GestaoLI',
        component: GestaoLIView,
      },
      {
        path: '/containers',
        name: 'Containers',
        component: ContainersView,
      },
      {
        path: 'dashboard-containers',
        name: 'DashboardContainers',
        component: DashboardContainerView,
      },
      // Empresas
      {
        path: '/empresas',
        name: 'Empresas',
        component: EmpresasView,
      },

      // Incentivo fiscal
      {
        path: '/incentivo-fiscal',
        name: 'incentivoFiscal',
        component: IncentivoFiscalView,
      },
      // Cadastros
      {
        path: '/cadastros',
        name: 'cadastrosBasicos',
        component: CadastroBasicoView,
      },
      // CRC
      {
        path: '/crc',
        name: 'crc',
        component: CrcView,
      },
      // Simulacao
      {
        path: '/simulacao',
        name: 'simulacao',
        component: SimulacaoView,
      },
      {
        path: '/processos-parceiros',
        name: 'processosParceiros',
        component: ProcessosParceirosView,
      },
      {
        path: '/processos-comissao',
        name: 'processosComissao',
        component: ProcessosComissaoView,
      },
      {
        path: '/detalhamento-despesas',
        name: 'despesasImportacaoDetalhamento',
        component: DespesasImportacaoDetalhamentoView,
      },
      {
        path: '*',
        redirect: {
          name: 'Home',
        },
      },
    ],
  },
];

export default routes;
